import * as Yup from 'yup';

const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required('Old password is required'),

  newPassword: Yup.string()
    .required('New password is required')
    .min(8, 'New password must be at least 8 characters')
    .matches(/[A-Z]/, 'New password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'New password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'New password must contain at least one number')
    .matches(/[@$!%*?&]/, 'New password must contain at least one special character'),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('Please confirm your new password'),
});

export default ChangePasswordSchema;
